import { render, staticRenderFns } from "./AllApplicantsTable.vue?vue&type=template&id=1af25fcc&scoped=true&"
import script from "./AllApplicantsTable.vue?vue&type=script&lang=ts&"
export * from "./AllApplicantsTable.vue?vue&type=script&lang=ts&"
import style0 from "./AllApplicantsTable.vue?vue&type=style&index=0&id=1af25fcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af25fcc",
  null
  
)

export default component.exports